import React from 'react'
import Login from '../../components/quickbooks/Login'

const QBLogin = () => {
  return (
    <Login />
  )
}

export default QBLogin